import {http} from "@/api/HttpClient"
import {Pageable, PageModel} from "@/api/Paging.ts";
import {CharacterSummary} from "@/characters/model/Character.ts";
import {SpellSummary} from "@/spells/model/Spell.ts";

export async function search(query: string, pageable: Pageable, signal?: AbortSignal): Promise<PageModel<SearchResult>> {
    const res = await http.get<PageModel<SearchResult>>(`/search`, {
        params: {...pageable, query},
        signal,
    });
    return res.data
}

export type SpellSearchResult = SpellSummary & {type: "SPELL"};
export type SearchResult = CharacterSummary | SpellSearchResult;
